import { roleLabel } from '../../../lib/role-labels';
import { useAuthStore } from '../../auth/store';

export function ProfileSection() {
  const user = useAuthStore((s) => s.user);
  if (!user) return null;

  const rows = [
    { term: 'E-mail', value: user.email },
    {
      term: 'Rôle',
      value: (
        <span className="inline-flex rounded-xl bg-teal-50 px-4 py-1.5 text-sm font-semibold capitalize text-emerald-950 ring-1 ring-emerald-900/30">
          {roleLabel(user.role)}
        </span>
      ),
    },
    {
      term: 'Membre depuis',
      value: new Date(user.createdAt).toLocaleDateString(undefined, { dateStyle: 'long' }),
    },
    {
      term: 'Identifiant utilisateur',
      value: <span className="break-all font-mono text-[0.8rem] text-slate-700">{user.id}</span>,
    },
  ] as const;

  return (
    <section className="app-card overflow-hidden">
      <div className="border-b border-slate-900/10 bg-gradient-to-r from-teal-50/90 to-transparent px-8 py-7">
        <h3 className="text-[0.9rem] font-semibold uppercase tracking-[0.1em] text-emerald-900/98">
          Profil
        </h3>
        <p className="mt-2 text-[0.85rem] text-slate-600">
          Données partagées avec les audits de sécurité.
        </p>
      </div>
      <dl className="divide-y divide-slate-100">
        {rows.map(({ term, value }) => (
          <div
            key={term}
            className="grid gap-x-16 gap-y-2 px-8 py-[1.4rem] sm:grid-cols-[10.5rem,minmax(0,1fr)]"
          >
            <dt className="app-label">{term}</dt>
            <dd className="text-[0.95rem] leading-relaxed text-slate-900">{value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
